<template>
  <div class="feladat-list-page">
    <navigation-bar />

    <div class="header">
      <div class="title-block">
        <h2>Szállítási feladatok</h2>

        <div class="filter-row">
          <label>Időszak:</label>
          <input type="date" v-model="selectedFromDate" />
          <input type="date" v-model="selectedToDate" />

          <label>Diszpécser:</label>
          <select v-model="selectedDisponent">
            <option value="all">Összes</option>
            <option
              v-for="d in disponents"
              :key="d.name"
              :value="d.name"
            >
              {{ d.name }}
            </option>
          </select>

          <button @click="loadData">Szűrés</button>
        </div>
      </div>

      <div class="header-actions">
        <button @click="$router.back()">Vissza</button>
      </div>
    </div>

    <div v-if="error" class="error">{{ error }}</div>
    <div v-if="loading" class="loading">Adatok töltése…</div>

    <table v-if="!loading && rows.length" class="feladat-table">
      <thead>
        <tr>
          <th>Dátum</th>
          <th>Rendszám</th>
          <th>Státusz</th>
          <th>Viszonylat</th>
          <th>Sofőr</th>
          <th>Diszpécser</th>
        </tr>
      </thead>
      <tbody>
         <tr
            v-for="row in rows"
            :key="row.az"
            class="clickable-row"
            @click="openFeladat(row)"
          >
          <td>{{ row.datum }}</td>
          <td>{{ row.rendszam }}</td>
            <td>
              <span
                v-if="row.szallitas_status !== undefined"
                class="status-badge"
                :style="{ backgroundColor: statusBadge(row.szallitas_status).color }"
              >
                {{ statusBadge(row.szallitas_status).text }}
              </span>
            </td>


          <td>{{ row.viszonylat }}</td>
          <td>{{ row.sofor }}</td>
          <td>{{ row.diszpecser }}</td>
        </tr>
      </tbody>
    </table>

    <div v-if="!loading && !rows.length && !error" class="no-data">
      Nincs feladat a megadott szűrésre.
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import axiosInstance from '@/axiosInstance';
import NavigationBar from '@/views/NavigationBar.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'FeladatList',
  components: { NavigationBar },

  data() {
    return {
      selectedFromDate: dayjs().startOf('month').format('YYYY-MM-DD'),
      selectedToDate: dayjs().endOf('month').format('YYYY-MM-DD'),
      selectedDisponent: 'all',
      disponents: [],
      rows: [],
      loading: false,
      error: null
    };
  },

  computed: {
    ...mapGetters(['getUserData', 'getUserType']),

    ceg_az() {
      return this.getUserData ? this.getUserData.ceg_az : null;
    },

    // Datumswerte inkl. Uhrzeit wie im Postman-Test
    startDateTime() {
      return this.selectedFromDate + ' 00:00:00';
    },
    endDateTime() {
      return this.selectedToDate + ' 23:59:59';
    },

    diszpecserFilter() {
      return this.selectedDisponent === 'all'
        ? '%'
        : this.selectedDisponent;
    }
  },

  async mounted() {
    if (!this.ceg_az) {
      this.error = 'Hiányzik a cég_az.';
      return;
    }

    await this.fetchDisponents();
    await this.loadData();
  },

  methods: {

    openFeladat(row) {
      if (!row?.az) return;
      this.$router.push({
        name: 'FeladatDetails',
        params: { id: row.az }
      });
    },

  statusBadge(status) {
    const map = {
      0: { text: 'Tervezve', color: '#6c757d' },
      1: { text: 'Úton felrakóra', color: '#0d6efd' },
      2: { text: 'Felrakás', color: '#fd7e14' },
      3: { text: 'Úton lerakóra', color: '#20c997' },
      4: { text: 'Lerakás', color: '#ffc107' },
      5: { text: 'Lerakva / vár', color: '#8bc34a' },
      6: { text: 'Fuvar kész', color: '#198754' },
      9: { text: 'Problémás', color: '#dc3545' }
    };
    return map[status] || map[0];
  },
    
    async fetchDisponents() {
      try {
        const payload = {
          ceg_az: this.ceg_az,
          start: this.startDateTime,
          end: this.endDateTime,
          diszpecser:"%"
        };

console.log("payLoad",payload);

        const resp = await axiosInstance.post(
          '/napi_mellek/list_weekDiszpecser.php',
          payload,
          { headers: { 'Content-Type': 'application/json' } }
        );

        if (resp.data && resp.data.data) {
          this.disponents = resp.data.data.map(d => ({
            name: d.diszpecser
          }));

          // Wenn User ein Diszpécser ist → automatisch auswählen
          if (this.getUserType === 'diszpécser') {
            const userName = this.getUserData?.nev;
            const exists = this.disponents.some(d => d.name === userName);
            if (exists) {
              this.selectedDisponent = userName;
            }
          }
        } else {
          this.disponents = [];
        }
      } catch (e) {
        console.error('❌ Fehler bei fetchDisponents:', e);
        this.disponents = [];
      }
    },

            async loadData() {
            if (!this.ceg_az) return;

            this.loading = true;
            this.error = null;

            const payload = {
                ceg_az: this.ceg_az,
                start: this.startDateTime,
                end: this.endDateTime,
                diszpecser: this.diszpecserFilter
            };

            try {
                console.log('🔹 list_feladatok payload:', payload);

                const resp = await axiosInstance.post(
                '/m_feladat/list_feladatok.php',
                payload,
                { headers: { 'Content-Type': 'application/json' } }
                );

                console.log('🔹 list_feladatok raw response:', resp.data);

                this.rows = resp.data?.data || [];
            } catch (e) {
                console.error('❌ Hiba list_feladatok.php hívásánál:', e);
                this.error = 'Hiba történt a feladatok lekérése közben.';
                this.rows = [];
            } finally {
                this.loading = false;
            }
            }

  }
};
</script>

<style scoped>
.feladat-list-page {
  padding: 10px 16px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
}

.title-block h2 {
  margin: 0 0 8px 0;
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  font-size: 0.9rem;
}

.filter-row input,
.filter-row select {
  padding: 3px 6px;
  font-size: 0.9rem;
}

.header-actions {
  display: flex;
  gap: 8px;
}

.feladat-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.feladat-table th,
.feladat-table td {
  border: 1px solid #ccc;
  padding: 6px 8px;
  text-align: left;
}

.feladat-table th {
  background: #f1f3f5;
}

.loading,
.error,
.no-data {
  margin-top: 16px;
  font-size: 0.9rem;
}

.error {
  color: #b00020;
}

.status-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.75rem;
  color: #fff;
}

.clickable-row {
  cursor: pointer;
}

.clickable-row:hover {
  background-color: #f5f5f5;
}


</style>
